import { MutationOptions, useMutation } from "react-query";
import {  AddCardData } from "../@types";
import { APIError, APIResponse, API_URL, post } from "../api";

export function getAddCardAuthorizationUrl(
  response?: APIResponse<AddCardData>
): string | undefined {
  const nestedUrl = response?.data?.data?.authorization_url;
  const directUrl = (response?.data as unknown as { authorization_url?: string })
    ?.authorization_url;

  return nestedUrl || directUrl;
}

function useInitializeAddCard(
  options?: MutationOptions<
    APIResponse<AddCardData>,
    APIError,
    Record<any, any>
  >
) {
  const {
    mutate: initializeAddCard,
    isLoading: initializing,
    isError: isInitializeError,
    error: initializeAddCardError,
    data: addCardData,
  } = useMutation(
    async (variables) => {
      const token = localStorage.getItem("token");

      return await post(API_URL + "/account/banking/card",   {...variables, vendor: 'paystack'}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    },
    {
      ...options,
    }
  );

  return {
    initializeAddCard,
    initializing,
    isInitializeError,
    addCardData,
    initializeAddCardError,
  };
}

export default useInitializeAddCard;
